module.exports = __webpack_public_path__ + "static/media/sara.b37007d5.jpg";